module.exports = __webpack_public_path__ + "static/media/22.53a8fd2d.mp3";